// extracted by mini-css-extract-plugin
export default {"calendar_day":"calendar_calendar_day__b5nS9"};